export class Tips {
	message: string;
	url: string;
	label: string;
	button: boolean;
	tipId: number;

	constructor() {

	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/dashboard/models/tips.ts